module.exports = __webpack_public_path__ + "img/audit-icon.11a540c8.svg";